export enum CardStatus {
  valid = 'valid',
  expiring ='expiring',
  expired = 'expired',
}

export interface Card {
  status: string;
  id: string;
  last4: string;
  expiryMonth: number;
  expiryYear: number;
  type: string;
}

export interface PaymentMethodProps {
  card: Card;
  isPrimary: boolean;
  isBackup: boolean;
  isSubscription: boolean;
  removeCard: (cardId: string) => void;
  setSubscriptionCard: (cardId: string) => void;
  setBackupCard: (cardId: string) => void;
  setPrimaryCard: (cardId: string) => void;
  isLine?: boolean;
}

export interface MenuItem {
  text: string;
  onClick: () => void;
}


export interface PaymentMethodViewProps {
  isPrimary: boolean;
  isBackup: boolean;
  isSubscription: boolean;
  onCardClick: () => void;
  cardLast4: string;
  cardType: string;
  expiryString: string;
  menuItems: MenuItem[];
}
